import { connect } from 'react-redux';
import { loadAll } from './moviesActions';
import Movies from './Movies';

const mapStateToProps = (state) => {
    const { error, isLoading, movies } = state.movies;
    return {
        error,
        isLoading,
        movies
    };
};

const mapDispatchToProps = (dispatch) => ({
    loadAll: (args) => dispatch(loadAll(args)),
});

const connected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Movies);

export default connected;
